import StoreCard from './store-card';
import Pagination from 'rc-pagination';
import { ReactNode } from 'react';
import { RenderProps } from '../../store-cards';

const PaginationItem = (page: number, type: string, element: ReactNode) => {
    switch (type) {
        case 'page': {
            return <div className="navigation-btns__btn">{page}</div>;
        }
        case 'prev': {
            return (
                <div className="navigation-btns__btn--prev">
                    <svg
                        className="icon"
                        width="12"
                        height="18"
                        viewBox="0 0 12 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 16.37L2 9l8-7.369"
                            stroke="#000"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </div>
            );
        }
        case 'next': {
            return (
                <div className="navigation-btns__btn--next">
                    <svg
                        className="icon"
                        width="12"
                        height="18"
                        viewBox="0 0 12 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 16.37L2 9l8-7.369"
                            stroke="#000"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </div>
            );
        }
        case 'jump-prev':
        case 'jump-next': {
            return <div className="navigation-btns__btn">...</div>;
        }
    }
    return element;
};

export default function StoreList({ stores, total, page, setPage, pageSize }: RenderProps) {
    return (
        <div className="w-100">
            <section className="w-100">
                <div className="data-container">
                    <div style={{ width: '1026px' }}>
                        {stores.map((s) => (
                            <StoreCard key={s.id} store={s} />
                        ))}
                    </div>
                </div>
                <div>
                    <div className="paginationjs">
                        <Pagination
                            className="paginationjs-pages"
                            pageSize={pageSize}
                            current={page}
                            showLessItems
                            onChange={setPage}
                            total={total}
                            itemRender={PaginationItem}
                            showTitle={false}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
